export default __webpack_public_path__ + "src/assets/broadcast-transaction.7490dd3d6decafe96c0689be6c9b3f33.svg";